<template>
  <div>
    <div class="vx-row mb-6" style="width: 50%">
      <div class="vx-col sm:w-1/3 w-full flex items-center">
        <span>Status</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <v-select
          :searchable="true"
          :options="optionStatus"
          :clearable="true"
          v-model="selectedStatus"
        >
        </v-select>
      </div>
    </div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
            >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th sort-key="sku_code">SKU Code</vs-th>
        <vs-th sort-key="sku_name">SKU Name</vs-th>
        <vs-th sort-key="sku_type">SKU Type</vs-th>
        <vs-th sort-key="uom">UOM</vs-th>
        <vs-th sort-key="tax">Tax</vs-th>
        <vs-th sort-key="tax_type">Tax Type</vs-th>
        <vs-th sort-key="sub_tax">Sub Tax</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="category1">Category 1</vs-th>
        <vs-th sort-key="category2">Category 2</vs-th>
        <vs-th sort-key="category3">Category 3</vs-th>
        <vs-th sort-key="division">Division</vs-th>
        <vs-th sort-key="material1">Material 1</vs-th>
        <vs-th sort-key="material2">Material 2</vs-th>
        <vs-th sort-key="material3">Material 3</vs-th>
        <vs-th sort-key="material4">Material 4</vs-th>
        <vs-th sort-key="material5">Material 5</vs-th>
        <vs-th sort-key="classification">Classification</vs-th>
        <vs-th sort-key="source">Source</vs-th>
        <vs-th sort-key="control">Control</vs-th>
        <vs-th sort-key="expired_date">Expired Date</vs-th>
        <vs-th sort-key="cod_only">Cod Only</vs-th>
        <vs-th sort-key="consignment">Consigment</vs-th>
        <vs-th sort-key="supplier_name">Supplier Name</vs-th>
        <vs-th sort-key="supplier_code">Supplier Code</vs-th>
        <vs-th sort-key="principal">Principal</vs-th>
        <vs-th sort-key="external_code">External Code</vs-th>
        <vs-th sort-key="sku_mat_to_mat">SKU Mat To Mat</vs-th>
        <vs-th sort-key="sku_curah">SKU Curah</vs-th>
        <vs-th sort-key="combo">Combo</vs-th>
        <vs-th sort-key="add_info_code">Add Info Code</vs-th>
        <vs-th sort-key="facility_code">Facility Code</vs-th>
        <vs-th sort-key="hs_code">HS Code</vs-th>
        <vs-th sort-key="status">Status</vs-th>
        <vs-th sort-key="remark">Remark</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="tr.data.sku_code">
            {{ tr.data.sku_code }}
          </vs-td>
          <vs-td :data="tr.data.sku_name">
            {{ tr.data.sku_name }}
          </vs-td>
          <vs-td :data="tr.data.sku_type">
            {{ tr.data.sku_type }}
          </vs-td>
          <vs-td :data="tr.data.uom">
            {{ tr.data.uom }}
          </vs-td>
          <vs-td :data="tr.data.tax">
            {{ tr.data.tax }}
          </vs-td>
          <vs-td :data="tr.data.tax_type">
            {{ tr.data.tax_type }}
          </vs-td>
          <vs-td :data="tr.data.sub_tax">
            {{ tr.data.sub_tax }}
          </vs-td>
          <vs-td :data="tr.data.status">
            {{ tr.data.status }}
          </vs-td>
          <vs-td :data="tr.data.category1">
            {{ tr.data.category1 }}
          </vs-td>
          <vs-td :data="tr.data.category2">
            {{ tr.data.category2 }}
          </vs-td>
          <vs-td :data="tr.data.category3">
            {{ tr.data.category3 }}
          </vs-td>
          <vs-td :data="tr.data.division">
            {{ tr.data.division }}
          </vs-td>
          <vs-td :data="tr.data.material1">
            {{ tr.data.material1 }}
          </vs-td>
          <vs-td :data="tr.data.material2">
            {{ tr.data.material2 }}
          </vs-td>
          <vs-td :data="tr.data.material3">
            {{ tr.data.material3 }}
          </vs-td>
          <vs-td :data="tr.data.material4">
            {{ tr.data.material4 }}
          </vs-td>
          <vs-td :data="tr.data.material5">
            {{ tr.data.material5 }}
          </vs-td>
          <vs-td :data="tr.data.classification">
            {{ tr.data.classification }}
          </vs-td>
          <vs-td :data="tr.data.source">
            {{ tr.data.source }}
          </vs-td>
          <vs-td :data="tr.data.control">
            {{ tr.data.control }}
          </vs-td>
          <vs-td :data="tr.data.expired_date">
            {{ tr.data.expired_date }}
          </vs-td>
          <vs-td :data="tr.data.cod_only">
            {{ tr.data.cod_only }}
          </vs-td>
          <vs-td :data="tr.data.consignment">
            {{ tr.data.consignment }}
          </vs-td>
          <vs-td :data="tr.data.supplier_name">
            {{ tr.data.supplier_name }}
          </vs-td>
          <vs-td :data="tr.data.supplier_code">
            {{ tr.data.supplier_code }}
          </vs-td>
          <vs-td :data="tr.data.principal">
            {{ tr.data.principal }}
          </vs-td>
          <vs-td :data="tr.data.external_code">
            {{ tr.data.external_code }}
          </vs-td>
          <vs-td :data="tr.data.sku_mat_to_mat">
            {{ tr.data.sku_mat_to_mat }}
          </vs-td>
          <vs-td :data="tr.data.sku_curah">
            {{ tr.data.sku_curah }}
          </vs-td>
          <vs-td :data="tr.data.combo">
            {{ tr.data.combo }}
          </vs-td>
          <vs-td :data="tr.data.add_info_code">
            {{ tr.data.add_info_code }}
          </vs-td>
          <vs-td :data="tr.data.facility_code">
            {{ tr.data.facility_code }}
          </vs-td>
          <vs-td :data="tr.data.hs_code">
            {{ tr.data.hs_code }}
          </vs-td>
          <vs-td :data="tr.status">
            {{ tr.status }}
          </vs-td>
          <vs-td :data="tr.remark">
            {{ tr.remark }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";

export default {
  components: { vSelect },
  props: {
    baseUrl: {
      type: String,
    },
    logImportID: {
      type: Number,
    },
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD MMM YYYY");
      }
    },
  },
  data() {
    return {
      table: this.tableDefaultState(),
      optionStatus: [],
      selectedStatus: "",
      selectedSearchKeys: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },

    getData() {
      this.$vs.loading();
      const params = {
        length: this.table.length,
        page: this.table.page,
        search: this.table.search,
        order: this.table.order,
        sort: this.table.sort,
        log_import_id: this.logImportID,
        status: this.selectedStatus,
        search_keys: this.selectedSearchKeys.length > 0 ? this.selectedSearchKeys : ['']
      };

      this.$http
        .get("/api/wms/v1/master-import/log-import-line-v3", {params})
        .then((resp) => {
          if (resp.code == 200) {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;

            if (this.table.data && this.selectedSearchKeys.length === 0 && this.table.data.length > 0) {
              this.selectedSearchKeys = Object.keys(this.table.data[0].data)
                .filter(key => key !== "status" && key !== "remark");
            }

            if (this.table.data) {
              if (this.selectedStatus === "") {
                this.optionStatus = []
              }

              this.table.data.forEach(e => {
                if (!this.optionStatus.includes(e.status) && this.selectedStatus === "") {
                  this.optionStatus.push(e.status)
                }
              });
            }

            this.setStartEnd();
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.error(error);
          this.$vs.loading.close();
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
  },
  watch: {
    logImportID() {
      console.log('logImportID changed');
      this.getData();
    },
    selectedStatus() {
      console.log('selectedStatus changed');
      this.getData();
    },
    selectedSearchKeys() {
      console.log('selectedSearchKeys changed');
      this.getData();
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
